import { render, staticRenderFns } from "./TabMyPresentations.vue?vue&type=template&id=85b4c5b0"
import script from "./TabMyPresentations.vue?vue&type=script&lang=js"
export * from "./TabMyPresentations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports